import { render, staticRenderFns } from "./CoursesWrapper.vue?vue&type=template&id=e6c25e34&"
import script from "./CoursesWrapper.vue?vue&type=script&lang=js&"
export * from "./CoursesWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports